import { HSLColor } from '@yola/yola-palette-generator';
import border from '../../border';

const primary = (params) => {
  const { hue, saturation, lightness } = border.default.primary(params);

  return new HSLColor(hue, saturation, lightness, 0);
};

export default primary;
